export const isNumber = (entity: unknown): entity is number => typeof entity === 'number'
